import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Card';
import { Box, Typography } from '@material-ui/core';

type Props = {
  title: string;
  src: string;
  description: string;
};

const useStyles = makeStyles(() => ({
  paperContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '80px',
    width: '200px',
    borderRadius: '4px'
  }
}));

const ModuleCard: React.FC<Props> = ({ title, src, description }) => {
  const classes = useStyles();
  return (
    <Paper variant="outlined" className={classes.paperContainer}>
      <Box display="flex" padding="10px" width="100%" justifyContent="left" alignItems="center">
        <img height={48} width={48} src={src} alt={title} style={{ marginRight: 15 }} />

        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
            {title}
          </Typography>
          <Typography variant="subtitle2" style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
            {description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ModuleCard;
